import React from 'react';
import Masonry from 'react-masonry-css';
import Category from '../modules/models/category';
import CategoryComponent from './category';

const Categories = (props: any) => {
    return (
        <Masonry
            breakpointCols={{
                default: 4,
                1280: 3,
                1024: 2,
                768: 2,
                640: 1
            }}
            className="flex flex-wrap p-4 mx-auto lg:mt-20"
            columnClassName="w-auto">
            {
                props.cheatsheet.map((category: Category) =>{
                    if(category.title ? category.title.includes("XL") 
                        || category.title.includes("LG") 
                        || category.title.includes("MD") 
                        || category.title.includes("SM") : 0) return;
                    return <CategoryComponent key={category.title} category={category} />
                })
            }
        </Masonry>
    );
}

export default Categories;
